import { createRouter, createWebHashHistory } from 'vue-router'
import Index from '@/views/index.vue'
import Authorize from '@/views/login/authorize'

let routes = [
  {
    path: '/index',
    component: Index,
    name: 'Index',
    meta: {
      title: '首页'
    }
  },
  {
    path: '/authorize',
    component: Authorize,
    name: 'Authorize',
    meta: {
      title: '微信授权登录'
    }
  },
  { path: '/', redirect: '/index' },
]

routes = [...routes]
// console.log(routes)
const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
